import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "disabled", "id", "name"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "n-switch__icon" }, null, -1)
const _hoisted_3 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'n-switch',
      {
        'n-switch_checked': _ctx.modelValue,
        'n-switch_disabled': _ctx.disabled,
        'n-switch_focused': _ctx.focused
      }
    ]),
    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args)), ["prevent"]))
  }, [
    _createElementVNode("input", {
      value: _ctx.modelValue,
      class: "n-switch__input",
      type: "checkbox",
      disabled: _ctx.disabled,
      id: `checkbox-${_ctx.label}`,
      name: `checkbox-${_ctx.label}`,
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args))),
      onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.focused = true)),
      onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.focused = false))
    }, null, 40, _hoisted_1),
    _hoisted_2,
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createElementVNode("label", {
        for: `checkbox-${_ctx.label}`,
        class: "n-switch__label label-m"
      }, _toDisplayString(_ctx.label), 9, _hoisted_3)
    ])
  ], 2))
}